import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class SocialShare{

    constructor(private httpClient: HttpClient) {}

    saveSocialShare(data) { 
        return this.httpClient.post(`SocialShares/insert?postType=${data.postType}&postId=${data.postId}`, data);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/social-share.service.ts